// extracted by mini-css-extract-plugin
export default {"container":"headline_container__mf8MP","headline1":"headline_headline1__efBGj","headline3":"headline_headline3__ZvJVG","headline2":"headline_headline2__MdwO-"};